export default import('shrike-client');
